import React from 'react';
import { TestimonialCard } from './TestimonialCard';
export function OfferSection() {
  return <div className="w-full px-6 py-20" data-id="element-122">
      <div className="max-w-4xl mx-auto" data-id="element-123">
        <TestimonialCard text="Update on grandparents with peptides: He just called me to update me, he feels 20 years younger and she is doing yard work AND just did a 100 piece jigsaw puzzle (she's loved puzzles her whole life). 6 month ago she couldn't do a five piece jigsaw puzzle. I don't care what anyone says, peptides f**king work" highlight={true} profileImage="https://uploadthingy.s3.us-west-1.amazonaws.com/oEpan9Q2S1ziM4cjxAeF15/image.png" name="Kademila" data-id="element-124" />
      </div>
    </div>;
}